// Matchar DutyRoleId i backend
export enum DutyRole {
    UNDEFINED = 0,

    /// <summary>
    /// Rektor
    /// </summary>
    PRINCIPAL = 1,

    /// <summary>
    /// Lärare
    /// </summary>
    TEACHER = 2,

    /// <summary>
    /// Förskollärare
    /// </summary>
    LICENSED_PRESCHOOL_TEACHER = 3,

    /// <summary>
    /// Övrig pedagogisk personal
    /// </summary>
    OTHER_TEACHER = 4,

    /// <summary>
    /// Annan personal
    /// </summary>
    STAFF = 5,

    /// <summary>
    /// Förstelärare
    /// </summary>
    FIRST_TEACHER = 6,

    /// <summary>
    /// Förskolechef
    /// </summary>
    PRESCHOOL_PRINCIPAL = 7,

    /// <summary>
    /// Skoladministratör
    /// </summary>
    SCHOOL_ADMINISTRATOR = 8,

    /// <summary>
    /// Barnskötare
    /// </summary>
    LEGAL_NANNY = 9,

    /// <summary>
    /// Bibliotekarie
    /// </summary>
    LIBRARIAN = 10,

    /// <summary>
    /// Lärarassistent
    /// </summary>
    TEACHER_ASSISTANT = 11,

    /// <summary>
    /// Fritidspedagog
    /// </summary>
    RECREATION_PEDAGOGUE = 12,

    /// <summary>
    /// Studie- och yrkesvägledare
    /// </summary>
    STUDENT_COUNSELOR = 13,

    /// <summary>
    /// Kurator
    /// </summary>
    COUNSELOR = 14,

    /// <summary>
    /// Skolsköterska
    /// </summary>
    SCHOOL_NURSE = 15,

    /// <summary>
    /// Skolläkare
    /// </summary>
    SCHOOL_DOCTOR = 16,

    /// <summary>
    /// Skolpsykolog
    /// </summary>
    SCHOOL_PSYCHOLOGIST = 17,

    /// <summary>
    /// Speciallärare/specialpedagog
    /// </summary>
    SPECIAL_PEDAGOGUE = 18,

    /// <summary>
    /// Övrig arbetsledning
    /// </summary>
    OTHER_MANAGEMENT = 19,
}